import { ILoan } from "@/types/loan.type";

export const createClickableLink = (content: React.ReactNode, loanData: unknown, navigate: (url: string) => void, className = "cursor-pointer hover:underline hover:text-blue-500") => {
  const loan = loanData as ILoan;
  const url = `/financeiro/emprestimo/${loan._id}`;
  return (
    <a
      href={url}
      onClick={(e) => {
        e.preventDefault();
        navigate(url);
      }}
      className={className}
    >
      {content}
    </a>
  );
};
